/*
initializes and sets up main application.
*/

import GraphView from 'view/graph';
import GraphController from 'controller/graph';
import Graph from 'model/graph';

let initialNodes = [];
let initialLinks = [];

let g = new Graph(initialNodes, initialLinks);
let view = new GraphView(g);
let controller = new GraphController(g, view);

// controller.addConnectorNode('empty', -500, -500).hide();

/**
 * import data from database
 */
function importData() {
    g.loadFromDB();
    view.loadFromDB();
    controller.update();
}

/* auto-save */
function save() {
    if (g.nodes.length > 0 || view.nodes.length > 0){
        g.backup();
        view.backup();
    }
}

setTimeout(importData, 1500);
controller.addConnectorNode('empty', -500, -500).hide();
setInterval(save, 5000);

/* for testing purposes */

import {} from 'utilities/utilities';
import api from 'utilities/api';

import ImageNode from 'model/imageNode';
import Link from 'model/link';
import Node from 'model/node';
import NodeView from 'view/node';
import LinkView from 'view/link';

let debugging = true;

if (window.jasmine || debugging) {
    console.log('globals accessible');
    window.Graph = Graph;
    window.api = api;
    window.GraphView = GraphView;
    window.NodeView = NodeView;
    window.LinkView = LinkView;
    window.Node = Node;
    window.Link = Link;
    window.ImageNode = ImageNode;
    window.GraphController = GraphController;
    window.g =  g;
    window.view = view;
    window.controller = controller;
}
